<template>
    <div id="intro">
        <div class="intro-wrapper">
            <div class="intro-container">
                <div class="title" v-show="fireSwitch == true">
                    <h1>클릭하여 아래 불을 꺼주세요</h1>
                    <img src="../assets/arr-down.svg" alt="아래 화살표">
                </div>
                <div class="fire" :class="{ fireOn : fireSwitch }" v-show="fireSwitch == true">
                    <img src="../assets/candle_fire.svg" alt="불꽃" @click="fireSwitch = false">
                </div>
                <div class="fire-off" :class="{ fireOff : fireSwitch }" v-show="fireSwitch == false">
                    <svg version="1.1">
                        <path d="M45,196.2c0,0-44-19.2-44-66.4s66.1-35.5,66.1-76.5S36.5,1,36.5,1"/>
                    </svg>
                </div>
                <div class="candle">
                    <img src="../assets/candle.svg" alt="양초">
                </div>
                <div class="glow" v-show="fireSwitch == true"></div>
            </div>
        </div>
        <!-- <div class="invitation-wrapper">
            <div class="invitation-container">
                <div class="invitation-header">
                    <div class="context">
                        <h2>제 31회 건국대학교 시각광고디자인학과 졸업전시회</h2>
                    </div>
                    <div class="poster"></div>
                </div>
                <div class="invitation-body">
                    <div class="info">
                        <li v-for="(item, i) in inviteInfo" :key="i">{{item.el}}</li>
                    </div>
                </div>
                <div class="invitation-footer">
                    <div class="contact">
                        <li v-for="(item, i) in contactInfo" :key="i">
                            <a :href='item.url'>
                                <img :src="item.src" :alt="item.name"><br> {{item.name}}
                            </a>
                        </li>
                    </div>
                    <div class="btn-refresh" @click="$router.go(0)">
                        <img src="../assets/btn_refresh.svg" alt="">
                        <p>다시보기</p>   
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            fireSwitch : true,
            inviteInfo : [
                { el: `2019.10.24(Thu)-27(Sun)` },
                { el: `10:00 am - 18:00 pm` },
                { el: `홍익대학로아트센터 B2F` },
            ],
            contactInfo : [
                { src:require('../assets/instagram.svg'), name: `@2020kkuvad`, url: `https://www.instagram.com/2020kkuvad/` },
                { src:require('../assets/phone.svg'), name: `건국대 시각광고디자인학과`, url: `tel:043-840-3634` }
            ]
        }
    },
    computed: {
        switchOff(){
            return this.fireSwitch
        }
    },
    watch: {
        switchOff(e) {
            if( e == false ) {
                this.$store.commit('fireOff', document.querySelector('.fire-off path'))
                this.openMain()
            }
        }
    },
    mounted() {
        this.$store.commit('upDown', document.querySelector('.title img'))
    },
    methods: {
        openMain(){
            setTimeout(() => {
                this.$router.push('/main')
            }, 3000);
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:900&display=swap');
* {
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 900;
}
*::selection {
    color: #ed86a1;
    background: #000;
}
a:link, a:active, a:visited {
	text-decoration: none;
	color: #000;
}
@media all and (min-width: 768px) {
    #intro {
        width: 100vw;
        height: 100vh;
        background: #000;
        position: relative;
        overflow: hidden;
    }
    .intro-wrapper {
        width: 96vw;
        height: 100vh;
        margin: 0 auto;
        overflow: hidden;
    }
    .intro-container {
        width: 96vw;
        height: 100vh;
        margin: 0 auto;
        text-align: center;
    }
    /* 타이틀 */
    .title {
        width: 100vw;
        margin: 0 auto;
        text-align: center;
        color: #ed86a1;
        position: absolute;
        font-size: 1.4rem;
        top: 15vh;
    }
    .title img {
        width: 32px;
        margin: 16px 0 0;
    }
    /* 촛불 */
    .fire {
        width: 100vw;
        height: 100px;
        text-align: center;
        position: absolute;
        bottom: 550px;
        z-index: 4;
    }
    .fire img {
        width: 80px;
        animation-name: flicker;
        animation-duration: 0.8s;
        animation-delay: 200ms;
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        cursor: pointer;
    }
    @keyframes flicker{
        0%   {transform: rotate(-0.7deg);}
        20%  {transform: rotate(0.5deg); opacity: 0.85;}
        40%  {transform: rotate(-0.2deg); opacity: 1;}
        60%  {transform: rotate(0.4deg) scaleY(1.02);}
        80%  {transform: rotate(-0.1deg) scaleY(0.98); opacity: 0.97;}
        100% {transform: rotate(0.4deg); opacity: 1;}
    }
    .fire-off {
        display: block;
        width: 200px;
        text-align: center;
        position: absolute;
        left: 50%;
        bottom: 480px;
        z-index: 2;
    }
    .fire-off svg {
        margin: 0 auto;
        text-align: center;
        stroke: #ed86a1;
        stroke-width: 2;
        stroke-linecap: round;
        background-color: none;
    }
    .fire-off svg path {
        opacity: 0;
        background-color: none;
    }
    .candle {
        width: 100vw;
        height: 400px;
        margin: 0 auto;
        text-align: center;
        overflow-y: hidden;
        position: absolute;
        bottom: 0;
        z-index: 3;
    }
    .candle img {
        width: 280px;
    }
    .glow {
        width: 600px;
        height: 600px;
        background: url('../assets/glow.svg');
        position: absolute;
        bottom: 190px;
        left: calc(50vw - 270px);
        animation-name: flicker;
        animation-duration: 1s;
        animation-delay: 200ms;
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }   

    /* 초대장 */
    .invitation-wrapper {
        width: 92vw;
        height: 92vh;
        margin: 0 auto;
        position: absolute;
        z-index: 10;
        top: 1030px;
        left: 4vw;
        background: #ed86a1;
        opacity: 0;
        color: #000 !important;
    }
    .invitation-container {
        width: 92vw;
        height: 92vh;
        margin: 0 auto;
        overflow-x: hidden;
        /* overflow-y: scroll; */
    }

    .invitation-header {
        width: 88vw;
        margin: 32px auto;
    }
    .invitation-header .poster {
        width: 88vw;
        height: 75vh;
        margin: 16px auto;
        background: #000;
        background: url('../assets/poster_web.png') no-repeat;
        background-size: contain;
        background-position-x: center;
    }
    .invitation-header .poster img {
        height: 320px;
    }
    .invitation-header .context {
        text-align: center;
        font-size: 1.1rem;
    }

    .invitation-body {
        width: 88vw;
        margin: 48px auto 88px;
    }
    .invitation-body .info {
        width: 88vw;
        list-style: none;
        font-size: 1.7rem;
        text-align: center;
    }
    .invitation-body .info li {
        width: 24vw;
        display: inline-block;
    }
    .invitation-body .info li:first-child {
        text-align: left;
    }
    .invitation-body .info li:nth-child(2) {
        text-align: center;
        margin: 0 2vw;
    }
    .invitation-body .info li:last-child {
        text-align: right;
    }

    .invitation-footer {
        width: 88vw;
        margin: 80px auto 24px;
        padding-bottom: 32px;
    }
    .invitation-footer .contact {
        width: 88vw;
        margin: 0 auto;
        text-align: center;   
    }
    .invitation-footer .contact h3 {
        font-size: 1.2rem;
        margin: 16px auto;
        text-align: center;
    }
    .invitation-footer .contact li{
        width: 14vw;
        font-size: 0.8rem;
        list-style: none;
        display: inline-block;
        text-align: center;
    }
    .invitation-footer .contact li img {
        width: 42px;
        margin: 8px auto;
    }

    .btn-refresh {
        width: 5vw;
        text-align: center;
        position: relative;
        left: 84vw;
        cursor: pointer;
        
    }
    .btn-refresh img {
        width: 32px;
        margin: 8px auto;
    }
}


@media all and (max-width: 767px) {
    #intro {
        width: 100vw;
        height: 100vh;
        min-height: 812px;
        background: #000;
        position: relative;
        overflow-y: hidden;
    }
    .intro-wrapper {
        width: 96vw;
        height: 100vh;
        min-height: 812px;
        overflow: hidden;
        margin: 0 auto;
        display: table;
    }
    .intro-container {
        width: 96vw;
        height: 100vh;
        min-height: 812px;
        margin: 0 auto;
        display: table-cell;
        vertical-align: bottom;
        text-align: center;
    }
    /* 타이틀 */
    .title {
        width: 100vw;
        margin: 0 auto;
        text-align: center;
        color: #ed86a1;
        position: absolute;
        top: 120px;
    }
    .title img {
        width: 24px;
        margin: 16px 0 0;
    }

    /* 촛불 */
    .fire {
        width: 100vw;
        height: 100px;
        text-align: center;
        position: absolute;
        bottom: 480px;
        z-index: 4;
    }
    .fire img {
        width: 56px;
        animation-name: flicker;
        animation-duration: 0.8s;
        animation-delay: 200ms;
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }
    @keyframes flicker{
        0%   {transform: rotate(-0.7deg);}
        20%  {transform: rotate(0.5deg); opacity: 0.85;}
        40%  {transform: rotate(-0.2deg); opacity: 1;}
        60%  {transform: rotate(0.4deg) scaleY(1.02);}
        80%  {transform: rotate(-0.1deg) scaleY(0.98); opacity: 0.97;}
        100% {transform: rotate(0.4deg); opacity: 1;}
    }
    .fire-off {
        display: block;
        width: 30px;
        height: 120px;
        margin: 50px auto;
        text-align: center;
        position: relative;
        z-index: 2;
    }
    .fire-off svg {
        margin: 0 auto;
        text-align: center;
        stroke: #ed86a1;
        stroke-width: 2;
        stroke-linecap: round;
        background-color: none;
    }
    .fire-off svg path {
        opacity: 0;
        background-color: none;
    }
    .candle {
        width: 100vw;
        height: 400px;
        margin: 0 auto;
        text-align: center;
        overflow-y: hidden;
        position: relative;
        z-index: 3;
    }
    .candle img {
        width: 180px;
    }
    .glow {
        width: 400px;
        height: 400px;
        background: url('../assets/glow.svg');
        position: absolute;
        bottom: 260px;
        left: calc(50% - 200px);
        animation-name: flicker;
        animation-duration: 1s;
        animation-delay: 200ms;
        animation-timing-function: ease-in;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }   

    /* 초대장 */
    .invitation-wrapper {
        width: 92vw;
        height: 90vh;
        margin: 0 auto;
        position: absolute;
        z-index: 10;
        top: 1020px;
        left: 4vw;
        background: #ed86a1;
        opacity: 0;
        color: #000 !important;
    }
    .invitation-container {
        width: 92vw;
        height: 90vh;
        margin: 0 auto;
        overflow-y: scroll;
    }
    .invitation-header {
        width: 88vw;
        margin: 32px auto;
    }
    .invitation-header h2 {
        font-size: 0.8rem;
    }
    .invitation-header .poster {
        width: 100%;
        height: 462px;
        margin: 16px auto;
        background: url('../assets/poster_mobile.png') no-repeat;
        background-size: contain;
        background-position-x: center;
    }
    .invitation-header .context {
        text-align: center;
        font-size: 0.9rem;
    }

    .invitation-body {
        width: 88vw;
        margin: 56px auto 0;
    }
    .invitation-body .info {
        width: 88vw;
        list-style: none;
        font-size: 1.3rem;
        line-height: 2.1rem;
        text-align: center;
    }

    .invitation-footer {
        width: 88vw;
        margin: 56px auto 32px;
        padding-bottom: 32px;
    }
    .invitation-footer .contact h3 {
        font-size: 1.2rem;
        margin: 16px auto;
        text-align: center;
    }
    .invitation-footer .contact li{
        width: 43vw;
        font-size: 0.7rem;
        list-style: none;
        display: inline-block;
        text-align: center;
    }
    .invitation-footer .contact li img {
        width: 42px;
        margin: 8px auto;
    }

    .btn-refresh {
        width: 56px;
        text-align: center;
        position: relative;
        cursor: pointer;
        font-size: 0.7rem;
        top: 48px;
        left: 71vw;
    }
    .btn-refresh img {
        width: 16px;
        margin: 4px auto;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/AppIntro.vue